import { useNavigate } from "react-router-dom";

const useMyNavigation = () => {
    const navigate = useNavigate();
    const navigation = (path) => {
        const urlPrefix = process.env.URL_PREFIX || '';
        const prefixedPath = `${urlPrefix}${path}`;
        navigate(prefixedPath);
    };
    return navigation;
};

export default useMyNavigation;